// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--aqdwi";
export var main = "styles-module--main--RoF7m";